<span class="amount-box amount-value">{{ amount | currencyLocale: null:null:'1.2-2' | lT  }}</span>
